import { render } from "./ArticleOnMAgazine.vue?vue&type=template&id=71b868c2"
import script from "./ArticleOnMAgazine.vue?vue&type=script&lang=js"
export * from "./ArticleOnMAgazine.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__